import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, LockKeyhole, ShieldCheck, Zap } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative overflow-hidden bg-cream px-4 pb-16 pt-10 text-center sm:pt-16" data-id="element-100" data-mp="9kjvumdkz02m">
      <div className="absolute left-1/2 top-0 h-64 w-[600px] -translate-x-1/2 rounded-full bg-[#F4E6C3]/60 blur-3xl" data-id="element-101" data-mp="4lyxkshw2qgt" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center" data-id="element-102" data-mp="129qwbqwlhzqi">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} className="rounded-full border border-gold/30 bg-white px-3 py-1 text-[10px] font-semibold tracking-wide text-gold-dark sm:text-sm" data-id="element-103" data-mp="xanpq20yvlgf">
          MEGA PACK HISTORIA 360
        </motion.div>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mt-5 max-w-4xl font-serif text-3xl font-bold leading-tight text-navy sm:text-5xl lg:text-6xl" data-id="element-104" data-mp="3cz5v8bjvq00c">
          Resuelve un año entero de clases de Historia en solo{' '}
          <span className="text-gold" data-id="element-105" data-mp="3e8wkcr4d12mf">5 MINUTOS.</span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="relative my-6 w-full max-w-[280px] sm:max-w-lg" data-id="element-106" data-mp="3eb91j22an8yf">
          <div className="absolute inset-x-12 bottom-4 h-10 rounded-full bg-navy/15 blur-2xl" data-id="element-107" data-mp="2vieucuawwl4r" />
          <img className="relative w-full drop-shadow-[0_18px_22px_rgba(16,42,67,.18)]" src="https://cdn.magicpatterns.com/uploads/rvyQFKE5WWsmCxiY9mRHMr/seguridad_e_higiene_(4).png" alt="Mega Pack Historia 360" data-id="element-108" data-mp="2hjf2zew0ls4w" />
        </motion.div>
        <p className="max-w-2xl text-sm leading-relaxed text-ink sm:text-lg" data-id="element-109" data-mp="nbbcwylbob5a">
          El sistema completo para planificar, enseñar y evaluar — listo para
          usar desde hoy.
        </p>
        <Button href="#pricing" className="my-6 px-8 py-4 text-sm sm:text-lg" data-id="element-110" data-mp="i9vpx0zl3uk9">
          QUIERO MI MEGA PACK AHORA
        </Button>
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-medium text-ink" data-id="element-111" data-mp="1b1fd0vzaxsrj">
          {[[CheckCircle2, '8 tomos premium'], [Zap, 'Acceso inmediato'], [LockKeyhole, 'Pago seguro'], [ShieldCheck, 'Garantía 7 días']].map(([Icon, label]) => {
          const ItemIcon = Icon as typeof CheckCircle2;
          return <span key={label as string} className="flex items-center gap-1.5" data-id="element-112" data-mp="3lt74sotvtnt7">
                <ItemIcon size={15} className="text-green" data-id="element-113" data-mp="3hqu1s86is404" />
                {label as string}
              </span>;
        })}
        </div>
      </div>
    </section>;
}